// fetch + JSON parse. Header-neutral: options pass through unchanged so callers
// control headers (the map proxy endpoints send Accept: application/json).
// Rejects on network, HTTP, or parse errors with a user-readable message.
export async function fetchJson(url, options = {}) {
  const res = await fetch(url, options)
  const text = await res.text()
  let data

  try {
    data = text ? JSON.parse(text) : {}
  } catch {
    throw new Error(res.ok ? "Invalid JSON response" : httpError(res))
  }

  if (!res.ok) throw new Error(data.error || data.message || httpError(res))
  return data
}

// One authenticated JSON request shape for Rails endpoints. Header overrides
// remain possible for exceptional callers, while the common CSRF and content
// negotiation contract cannot drift between features.
export function authenticatedJsonRequest(options = {}, csrfToken = null) {
  return {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken ?? currentCsrfToken(),
      ...(options.headers || {})
    }
  }
}

export function apiFetch(url, options = {}) {
  return fetch(url, authenticatedJsonRequest(options))
}

export function apiFetchJson(url, options = {}) {
  return fetchJson(url, authenticatedJsonRequest(options))
}

function currentCsrfToken() {
  if (typeof document === "undefined") return ""
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}

function httpError(res) {
  return `HTTP ${res.status}${res.statusText ? ` ${res.statusText}` : ""}`
}
